import { IUpdateDiarioObraUseCase } from "../../../presentation/useCases/update/update_diario_obras_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// UpdateDiarioObraUseCase

export class UpdateDiarioObraUseCase implements IUpdateDiarioObraUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async updateDiarioObra(
    IdDiarioObras: number,
    IdCentroCusto: number | null,
    IdCliente: number | null,
    IdClienteCentroCusto: number | null,
    IdFuncionarioResponsavel: number | null,
    IdFuncionarioAprovador: number | null,
    NumeroDocumento: string | null,
    DataCadastro: Date | null,
    ResponsavelPor: string | null,
    AprovadoPor: string | null,
    CondicaoTempo: string | null,
    DiaPraticavel: number | null,
    Observacao: string | null,
    Status: number | null,
    JustificativaDia: string | null,
    AssinaturaCliente: string | null,
    AssinaturaConstrutora: string | null,
    NroDiario: number | null,
    DataAlteracao: Date | null,
    HorarioTrabalhoDe: string | null,
    HorarioTrabalhoAte: string | null,
    HorarioAlmocoDe: string | null,
    HorarioAlmocoAte: string | null,
  ): Promise<void> {
    await this.repository.updateDiarioObra(
      IdDiarioObras,
      IdCentroCusto,
      IdCliente,
      IdClienteCentroCusto,
      IdFuncionarioResponsavel,
      IdFuncionarioAprovador,
      NumeroDocumento,
      DataCadastro,
      ResponsavelPor,
      AprovadoPor,
      CondicaoTempo,
      DiaPraticavel,
      Observacao,
      Status,
      JustificativaDia,
      AssinaturaCliente,
      AssinaturaConstrutora,
      NroDiario,
      DataAlteracao,
      HorarioTrabalhoDe,
      HorarioTrabalhoAte,
      HorarioAlmocoDe,
      HorarioAlmocoAte,
    );
  }
}
